// extracted by mini-css-extract-plugin
module.exports = {"primaryColour":"#1f2937","secondaryColour":"#f0bc74"};